import React, { useEffect, useState} from 'react';
import { Bounce } from 'react-reveal';
import { Button, Dropdown, Input } from 'semantic-ui-react';
import GConf from '../AssetsM/generalConf';
import { Menu, Tab } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { QrReader } from 'react-qr-reader';
import FullCalendar from '@fullcalendar/react' // must go before plugins
import timeGridPlugin from '@fullcalendar/timegrid';
import { toast } from 'react-toastify';



const ScanCodeCard = ({scanResultSeance,setScannedCode,scannedCode,setScanResultSeance,SelectClientFunction}) => {
   const SelectPatientBYQRCard = () => {
        return(<>
            {/* <h5 className='mt-2 mb-0 text-center text-secondary'>Scannez Le UID du Patient</h5> */}
            <QrReader
                constraints={{  facingMode: 'environment' }}
                scanDelay={500}
                onResult={(result, error) => {
                if (!!result) {  SelectClientFunction(result.text); setScanResultSeance(false) }
                if (!!error) { console.log(error);  }
                }}
                style={{  width: "150px",height: "150px" }}
            />

        </>)
}

      return(<>
            <div className='card-body'>
              {scanResultSeance ? <SelectPatientBYQRCard /> : 
              <>
                  <div className='card card-body shadow border-div d-flex justify-content-center align-items-center mb-3' >
                    <img src='https://cdn.abyedh.com/Images/required/qr-code.gif'  width={'250px'} height={'250px'} />
                  </div>
                  
                  <Button fluid className='text-white' onClick={()=> setScanResultSeance(!scanResultSeance)} style={{background: 'linear-gradient(to right, #c7228d, #c4063c)'}} >  Scannez votre seance ! </Button> 
              </>
              }
              <h1 className='text-center text-secondary'>{scannedCode}</h1>
              <hr />
              <h5>Ou bien entrer le code ici </h5>

              <div className='mb-3'>
                  <Input  icon='key' size='large' iconPosition='left' placeholder='Aa' type='password' className='shadow-sm w-100' onChange={(e) => setScannedCode(e.target.value)}/>
              </div>
              <div className='mb-3'>
                    <Button fluid className='text-white' onClick={()=> SelectClientFunction(scannedCode)} style={{background: 'linear-gradient(to right, #ddf506, #c4063c)'}} >  Marquer Presence! </Button> 
              </div>
            </div>
      </>)
    }

function EtudiantLandingPage() {
    /*#########################[Const]###########################*/
    let EtudiantData = JSON.parse(localStorage.getItem("EtudiantData"));
    let [creditValue, setCreditValue] = useState(0)
    const inputIsLogged = JSON.parse(localStorage.getItem('EtudiantData'));
    const [activeIndex, setActiveIndex] = useState(0)
    const [scanResultSeance, setScanResultSeance] = useState(false);
    let [statListe, setStatListe] = useState([])
    let [listeToShow, setListeToShow] = useState([])
    let [scannedCode, setScannedCode] = useState(null)
    const panesRes = [
      {
        menuItem: { key: 'attent',  content: <span className='text-warning'><b><span className='bi bi-hourglass-split'></span> En Attent</b></span> , className:'rounded-pill'},
        render: () => <div> <ScanCodeCard scanResultSeance={scanResultSeance} setScannedCode={setScannedCode} scannedCode={scannedCode} setScanResultSeance={setScanResultSeance} SelectClientFunction={SelectClientFunction} /></div>,
      },
      // {
      //   menuItem: { key: 'vu',  content: <span className='text-warning'><b><span className='bi bi-hourglass-split'></span> En Attent</b></span> , className:'rounded-pill'},
      //   render: () => <div> Emploi de temps du groupe  <CalendarCard /> </div>,
      // },
      {
        menuItem: { key: 'accept',  content: <span className='text-success'><b><span className='bi bi-check-square-fill'></span> Accepteé</b></span> , className:'rounded-pill' },
        render: () => <div><MatiereListeCard /> </div>,
      },
      {
        menuItem: { key: 'pr',  content: <span className='text-success'><b><span className='bi bi-check-square-fill'></span> Accepteé</b></span> , className:'rounded-pill' },
        render: () => <div> <EditProfileCard /> </div>,
      },
       
    ]

    /*#########################[UseEffect]###########################*/
    useEffect(() => {
        const inputIsLogged = JSON.parse(localStorage.getItem('EtudiantData'));
        if (!inputIsLogged) {window.location.href = "/Etudiant/logIn";}
         
        axios.post(`${GConf.ApiLink}/etudiant/faire-stat`, {
            e_groupe : EtudiantData.e_groupe
        })
        .then(function (response) {
             //console.log(response.data)
             setStatListe(response.data)
        })
    },[])

    /*#########################[Function]###########################*/
    const logOutInput = () =>{    
        localStorage.removeItem('EtudiantData');
        window.location.href = "/";
    }

    const SelectClientFunction = (value) => {
        setScannedCode(value)
        axios.post(`${GConf.ApiLink}/etudiant/ajouter-presence`, {
            ids : value,
            ide : EtudiantData.ide,
            e_groupe : EtudiantData.e_groupe
        })
        .then(function (response) {
             if (response.data.result == true) { toast.success("Presence Ajouter !", GConf.TostSuucessGonf) } 
             else if (response.data.sessionIsDispo == false) { toast.error(" Seance Fermeé !", GConf.TostErrorGonf) } 
             else if (response.data.etudiantEtEnGroupe == false) { toast.error(" Groupe Invalide  !", GConf.TostErrorGonf) } 
             else if (response.data.etudiantDejaPresent == true) { toast.error(" Tu est deja Present  !", GConf.TostErrorGonf) } 
             else {
              toast.error(" Autre errur   !", GConf.TostErrorGonf)
             }
             
        })
    }
    /*#########################[Card]###########################*/
    const MainTopCard = () =>{
        return(<>
            <div className='card p-3 fixed-top border-0 shadow-sm  rounded-0'>
                <div className='row'>
                    <div className='col-4 align-self-center'>
                        <NavLink exact='true' to='/'>
                            <span className='bi bi-arrow-left-short bi-md text-primary'></span>
                        </NavLink>

                    </div>
                    <div className='col-8 align-self-center text-end' ><h2> <span className="badge bg-info"> <span className='bi bi-person '></span>  {EtudiantData.e_nom} </span></h2></div>
                    
                </div>
            </div>
        </>)
    }

    const CustomTabs = () => {
      return(<>
        <div className='row mb-3'>
          <div className='col-12 col-lg-10 align-self-center' >
            <div style={{width:'100%', overflowX: 'auto', overflowY : 'hidden',  whiteSpace:'nowrap'}}>
              <Menu secondary >
                  <Menu.Item active={activeIndex == 0} className='rounded-pill' onClick={ () => setActiveIndex(0)}>
                    <span className='text ' style={{color: '#880a94'}}>
                      <b>
                        <span className='bi bi-qr-code-scan'></span> Marquer presence 
                      </b>
                    </span>
                  </Menu.Item>
                  {/* <Menu.Item active={activeIndex == 1} className='rounded-pill' onClick={ () => setActiveIndex(1)}>
                    <span className='text ' style={{color: '#00b8e6'}}>
                      <b>
                        <span className='bi bi-calendar-week'></span> Mon Emploi 
                      </b>
                    </span>
                  </Menu.Item> */}
                  <Menu.Item active={activeIndex == 1} className='rounded-pill' onClick={ () => setActiveIndex(1)}>
                    <span className='text' style={{color: '#e69500'}}>
                      <b>
                        <span className='bi bi-exclamation-triangle-fill'></span> Avertissements
                      </b>
                    </span>
                  </Menu.Item>
                 <Menu.Item active={activeIndex == 2} className='rounded-pill' onClick={ () => setActiveIndex(2)}>
                    <span className='text' style={{color: '#4e4d4b'}}>
                      <b>
                        <span className='bi bi-person-circle'></span> Mon Profile
                      </b>
                    </span>
                  </Menu.Item>
                  {/*  <Menu.Item active={activeIndex == 4} className='rounded-pill' onClick={ () => setActiveIndex(4)}>
                    <span style={{color:'#ab009d'}}>
                      <b>
                        <span className='bi bi-arrow-clockwise'></span> Retardeé
                      </b>
                    </span>
                  </Menu.Item>
                  <Menu.Item active={activeIndex == 5} className='rounded-pill' onClick={ () => setActiveIndex(5)}>
                    <span style={{color:'#92ab03'}}>
                      <b>
                        <span className='bi bi-compass-fill'></span> Redirecteé
                      </b>
                    </span>
                  </Menu.Item> */}
                   
              </Menu>
            </div>
          </div>
          <div className='col-4 text-end'>
              {/* <Button icon='calendar alternate' className='rounded-pill bg-system-btn me-4' onClick={() => openEditModal('justOpen',true)} /> */}
              {/* <MainSubNavCard text='Calendrier' link='rq/calendrier' icon='calendar-week' /> */}
          </div>
        </div>
      </>)
    }

   

    
    const CalendarCard = ()=> {
      return(<>
      <div className='card card-body mb-4'>
          <FullCalendar 
                plugins={[ timeGridPlugin ]}
                initialView="timeGridWeek"
                locale='fr' 
                dayHeaderFormat = {{weekday: 'short'}}
                events={listeToShow}
                //eventClick={(clickInfo) => RemoveEvent(clickInfo.event)}
                headerToolbar='false'
                height='490px'
                allDaySlot= {false}
                slotMinTime = '08:00'  
                slotMaxTime = '18:00' 
            /> 
    </div>
      </>)
    }
    const MatiereListeCard = () => {
      const CalculateNumLesson = (m) =>{
        return statListe.filter(data => data.s_matiere === m).length
      }
      const CalculateNumPresence = (m,e) =>{
        let count = 0;

        const lessons = statListe.filter(data => data.s_matiere === m);

        lessons.forEach(lesson => {
          if (!lesson.s_presence) return; // "" or null → skip

          let presenceList;
          try {
            presenceList = JSON.parse(lesson.s_presence);
          } catch (err) {
            return; // invalid JSON → skip safely
          }
          console.log(presenceList)
          presenceList.forEach(p => {
            if (p.etuId === e && p.present === true) {
              count++;
            }
          });
        });

        return count;
      }

      const MatierCard = (props) => {
        return(<>
        <div className='card p-2 shadow-sm mb-2 border-div'>
            <div className="row">
                <div className="col-9"><b style={{color : props.data.matCol}}>{props.data.nom}</b></div>
                <div className="col-1"><b>{CalculateNumLesson(props.data.nom)}</b></div>
                <div className="col-1"><b style={{color : "#04cf1f"}}>{CalculateNumPresence(props.data.nom, EtudiantData.ide)}</b></div>
                <div className="col-1"><b style={{color : "#b80505"}}>{CalculateNumLesson(props.data.nom) - CalculateNumPresence(props.data.nom, EtudiantData.ide)}</b></div>
            </div>
          </div>
        </>)
      }
      return(<>
          {GConf.matiereListe.map((data,index) => <MatierCard key={index} data={data}  />)}
      </>)
    }
    const EditProfileCard = () => {
      let [etudiantData, setEtudiantData] = useState(EtudiantData);
      useEffect(() => {
          setEtudiantData({...etudiantData, e_groupe: parseInt(etudiantData.e_groupe) })
      },[])
      return(<>
        <div className='card card-body shadow border-div mb-4 col-12 col-lg-6'>
          <h3 className='text-secondary'>Modifier votre Profile </h3>
          <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> Nom du Etudiant : </h5>
            <Input  icon='user' iconPosition='left' placeholder='Nom .. ' value={etudiantData.e_nom || ''} className='shadow-sm w-100' onChange={(e) => setEtudiantData({...etudiantData, e_nom: e.target.value })}/>

            <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> E-mail du Etudiant : </h5>
            <Input  icon='mail' iconPosition='left' placeholder='E mail .. ' value={etudiantData.e_email || ''} className='shadow-sm w-100' onChange={(e) => setEtudiantData({...etudiantData, e_email: e.target.value })}/>

            <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> Groupe : </h5>
            {/* <Input  icon='user' iconPosition='left' placeholder='Nom .. ' className='shadow-sm w-100' onChange={(e) => setEtudiantData({...etudiantData, e_groupe: e.target.value })}/> */}
            <Dropdown
                search
                selection
                wrapSelection={false}
                options={GConf.groupeListe.map((data, index) => ({id : index, value: data.grid, text:`${data.spec} - ${data.grp} ` }))}
                placeholder='Selectionnez Groupe'
                className='mb-1 shadow-sm w-100'
                onChange={(e, { value }) => setEtudiantData({...etudiantData, e_groupe: value })}
                value={etudiantData.e_groupe}
            />
            <div className='mb-3 mt-3'>
                <Button onClick={() => alert()}  style={{backgroundColor: '#03a561', color:'white'}} className='shadow-sm w-100'> Modifer votre Compte </Button>
            </div>
            <Button onClick={logOutInput} style={{backgroundColor: '#272e2b'}} className='rounded text-white' icon='log out' >Deconnextion</Button>
        </div>
      </>)
    }

    return ( <>
            <MainTopCard />
            <br />                
            <br />                
            <br />                
            <br />   
                   
            <div className='container-fluid'>
                 
                <CustomTabs  /> 
                <Tab menu={{ secondary: true }} activeIndex={activeIndex} panes={panesRes}  className='no-menu-tabs mt-2' />
                 
            </div> 
              
        </> );
}

export default EtudiantLandingPage;